import Powerboard from "./components";

type PowerBoardServiceProps = {
    show: boolean;
    path: string;
};

const defaultConfig: PowerBoardServiceProps = {
    show: false,
    path: "/",
};

export const powerBoardService = ({ getConfig }: any) => {
    const powerboardConfig: PowerBoardServiceProps = getConfig("one.box.powerboard", defaultConfig);

    if (powerboardConfig?.show === false) {
        return [];
    }

    return [
        {
            target: "$ONE_LAYOUT_ROUTE",
            handler: {
                path: powerboardConfig.path ?? "/",
                component: Powerboard,
            },
        },
    ];
};
